import { render, staticRenderFns } from "./sealAndName.vue?vue&type=template&id=adc6d500&scoped=true"
import script from "./sealAndName.vue?vue&type=script&lang=js"
export * from "./sealAndName.vue?vue&type=script&lang=js"
import style0 from "./sealAndName.vue?vue&type=style&index=0&id=adc6d500&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc6d500",
  null
  
)

export default component.exports